// extracted by mini-css-extract-plugin
export default {"theme-container":"SectionContentComponent_theme-container__VCd0S","content":"SectionContentComponent_content__aXnZj","contentWide":"SectionContentComponent_contentWide__WPB0H"};